var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuPlashka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 728.3 88.9",
    style: {
      enableBackground: "new 0 0 728.3 88.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,85.9V1.8h70.3v84.1h-9V10.6H9v75.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3,0c24.1,0,43.8,19.7,43.8,43.8s-19.7,43.8-43.8,43.8c-24.1,0-43.7-19.7-43.7-43.8C83.5,19.7,103.1,0,127.3,0z  M127.4,78.9c19,0,34.5-16,34.5-35.1S146.4,8.7,127.4,8.7c-19.1,0-34.6,16-34.6,35.1S108.3,78.9,127.4,78.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,21.8c0,6.8-4.1,15.5-11.9,19.6c10.6,4.3,15.3,13,15.3,21.7c0,13.2-11.2,24.5-28,24.5c-12.1,0-21.9-5-29.8-13 l6.4-6.4c6.2,6.5,13.7,10.6,23.3,10.6c12,0,18.9-7.3,18.9-15.7c0-10.3-8.9-16.3-18.1-16.3h-11.2V38h10.7c10,0,15.3-8.6,15.3-16.2 c0-7.6-6-13-15.7-13c-9.6,0-15.9,4-22.1,10.3l-6.4-6.4C184.9,4.8,193.5,0,205.6,0C220.3,0.1,230.3,9.5,230.3,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3,85.9V1.8h35.9c12.4,0,22.5,10.1,22.5,22.5c0,6.8-3,13.1-9,17.2c9.4,4.2,12.9,11.8,12.9,20.5 c0,13.2-10.7,23.9-23.9,23.9L246.3,85.9L246.3,85.9z M255.3,10.5V38h26.4c7.6,0,13.7-6.2,13.7-13.8s-6.1-13.7-13.7-13.7H255.3z  M255.3,77.1h29.1c8.4,0,15-6.7,15-15.1c0-10.3-7.9-15.1-17.2-15.1h-26.9V77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,0c24.1,0,43.8,19.7,43.8,43.8S386,87.6,361.9,87.6s-43.7-19.7-43.7-43.8S337.7,0,361.9,0z M362,78.9 c19,0,34.5-16,34.5-35.1S381,8.7,362,8.7c-19.1,0-34.6,16-34.6,35.1S342.9,78.9,362,78.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,1.8v36.3h52.3V1.8h9v84.1h-9v-39H428v39h-9V1.8H428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.8,15.3l-62.7,73.6V1.7h9v63.1l53.7-63.1h9v84.1h-9V15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.5,1.8v8.8h-30v75.3h-9V10.6h-30V1.8H656.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.4,38c13.2,0,23.9,10.7,23.9,23.9s-10.7,23.9-23.9,23.9h-38.3V1.7h9V38L704.4,38L704.4,38z M675.1,77.1h29.1 c8.4,0,15.1-6.7,15.1-15.1c0-10.3-8-15.1-17.3-15.1h-26.9L675.1,77.1L675.1,77.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuPlashka);
export default __webpack_public_path__ + "static/media/RU_PLASHKA_позвонить.6ff2f128627dbb74daddef0e501eb803.svg";
export { ForwardRef as ReactComponent };